import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import {
  SHIPPING_SETTINGS_ROUTES,
  checkoutShippingQuoteResponseSchema,
  type CheckoutShippingQuote,
  type CheckoutShippingQuoteRequest,
} from "@nh/shared";
import { authFetch } from "@/shared/api/session";

/**
 * La cotización del envío en el checkout (13-oct-2026). El servidor
 * decide si el pedido cobra envío (`required`) y guarda la foto del
 * precio; aquí solo se pinta y se elige.
 */
export function quoteCheckoutShipping(
  input: CheckoutShippingQuoteRequest,
): Promise<CheckoutShippingQuote> {
  return authFetch(SHIPPING_SETTINGS_ROUTES.checkoutQuote, checkoutShippingQuoteResponseSchema, {
    baseUrl: "",
    method: "POST",
    body: input,
  }).then((data) => data.quote);
}

/**
 * Cotiza cuando hay dirección completa. La llave incluye renglones y
 * dirección: cambiar cualquiera vuelve a cotizar, porque el servidor
 * rechaza una foto de otro carrito o de otro CP.
 */
export function useCheckoutShippingQuote(
  input: CheckoutShippingQuoteRequest | null,
): UseQueryResult<CheckoutShippingQuote, Error> {
  return useQuery({
    queryKey: ["checkout", "shipping-quote", input],
    queryFn: () => quoteCheckoutShipping(input as CheckoutShippingQuoteRequest),
    enabled: input !== null,
    // La foto vale 2 horas en el servidor; se refresca antes de que venza.
    staleTime: 60 * 60 * 1000,
    retry: false,
  });
}
